import FilterLocationModalTrigger from './FilterLocationModalTrigger';
export default FilterLocationModalTrigger;